<template>
  <div class="redactor">
    <!-- <button @click="open()" class="redactor_add">+ Добавить файл</button> -->
    <v-dialog v-model="dialog" persistent max-width="846">
      <div class="add-files">
        <div class="add-files-label">
          <div class="add-files_header">
            <h2>Добавить файл</h2>
            <button class="filter-btn" @click="close()">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L13.7279 13.7279"
                  stroke="#CACDD3"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M1 14L13.7279 1.27208"
                  stroke="#CACDD3"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </button>
          </div>
          <div class="media-files_headline add-files-dialog">
            <div class="media-files_left">
              <div class="media-files_search">
                <label for="file">Поиск</label>
                <input
                  id="file"
                  v-model="search"
                  class="media-files_search-input"
                />
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.6679 11.6679C12.0584 11.2774 12.6916 11.2774 13.0821 11.6679L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.6679 13.0821C11.2774 12.6916 11.2774 12.0584 11.6679 11.6679Z"
                    fill="#4854FE"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.125 2C4.29454 2 2 4.29454 2 7.125C2 9.95546 4.29454 12.25 7.125 12.25C9.95546 12.25 12.25 9.95546 12.25 7.125C12.25 4.29454 9.95546 2 7.125 2ZM0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 11.06 11.06 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125Z"
                    fill="#4854FE"
                  />
                </svg>
              </div>
              <div class="media-files_switch">
                <label for="switch">Мои файлы</label>
                <v-switch
                  v-model="filter.author"
                  @change="mediaFilter(filter)"
                  color="primary"
                  id="switch"
                  :value="userName"
                  hide-details
                ></v-switch>
              </div>
              <div class="media-files_select">
                <label for="type">Тип файла</label>
                <v-select
                  id="type"
                  v-model="filter.fileType"
                  :items="mediaType"
                  class="media-files_search-select"
                  hide-details
                  @change="mediaFilter(filter)"
                  outlined
                ></v-select>
              </div>
            </div>
          </div>
          <div class="table">
            <v-data-table
              v-model="selected"
              show-select
              :headers="headers"
              :items="mediaData"
              class="elevation-1"
              ref="table"
              @pagination="paginations($event)"
              :page="page"
              hide-default-footer
              :items-per-page="itemsPerPage"
              :search="search"
            >
              <template v-slot:[`item.mediaFileTags`]="{ item }">
                <span>{{
                  item.mediaFileTags
                    .map((item) => {
                      return item.mediaFileTag.tagName;
                    })
                    .join(", ")
                }}</span>
              </template>

              <template v-slot:footer="{ props }">
                <div class="data-footer">
                  <div class="items-per-page">
                    <span>Строк на странице:</span>
                    <div
                      class="items-per-page_item"
                      :class="{ active: itemsPerPage == 5 }"
                      @click.prevent="itemsPerPage = 5"
                    >
                      5
                    </div>
                    <div
                      class="items-per-page_item"
                      :class="{ active: itemsPerPage == 10 }"
                      @click.prevent="itemsPerPage = 10"
                    >
                      10
                    </div>
                    <div
                      class="items-per-page_item"
                      :class="{ active: itemsPerPage == 15 }"
                      @click.prevent="itemsPerPage = 15"
                    >
                      15
                    </div>
                    <div
                      class="items-per-page_item"
                      :class="{ active: itemsPerPage == -1 }"
                      @click.prevent="itemsPerPage = -1"
                    >
                      все
                    </div>
                  </div>
                  <div class="pagination" v-if="itemsPerPage != -1">
                    <div
                      class="pagination_prev"
                      @click.prevent="page == 1 ? page : --page"
                    >
                      <svg
                        width="6"
                        height="11"
                        viewBox="0 0 6 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z"
                          fill="#94969C"
                        />
                      </svg>
                    </div>
                    <div class="pagination_number">
                      {{ itemsPerPage * (page - 1) + 1 }} -
                      {{ itemsPerPage * (page - 1) + itemsPerPage }} из
                      {{ props.pagination.itemsLength }}
                    </div>
                    <div
                      class="pagination_next"
                      v-if="itemsPerPage"
                      @click.prevent="
                        page ==
                        parseInt(
                          props.pagination.itemsLength / itemsPerPage,
                          10
                        )
                          ? page
                          : ++page
                      "
                    >
                      <svg
                        width="6"
                        height="11"
                        viewBox="0 0 6 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z"
                          fill="#94969C"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </template>
            </v-data-table>

            <button class="submit-add" @click="addFiles()">Добавить</button>
          </div>
        </div>
      </div>
    </v-dialog>
        <quill-editor
          class="editor"
          :key="currentNode ? currentNode.id : 0"
          :content="convertContentToQuill()"
          ref="myQuillEditor"
          :options="editorOption"
          @change="onEditorChange($event)"
        >
          <div id="toolbar" slot="toolbar">
            <span class="ql-formats">
                <button class="ql-bold">Bold</button>
                <button class="ql-italic">Italic</button>
                <button class="ql-underline">Italic</button>
                <button class="ql-strike">Italic</button>
            </span>
            <span class="ql-formats">
                <button class="ql-blockquote">Italic</button>
                <button class="ql-code-block">Italic</button>
            </span>
            <span class="ql-formats">
                <button class="ql-header" value="1">H1</button>
                <button class="ql-header" value="2">H2</button>
            </span>
            <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
            </span>
            <span class="ql-formats">
                <button class="ql-script" value="sub"></button>
                <button class="ql-script" value="super"></button>
            </span>
            <span class="ql-formats">
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
            </span>
            <span class="ql-formats">
                <button class="ql-direction" value="rtl"></button>
            </span>
            <span class="ql-formats">
                <select class="ql-size">
                    <option value="small"></option>
                    <option selected></option>
                    <option value="large"></option>
                    <option value="huge"></option>
                </select>
            </span>
            <span class="ql-formats">
                <select class="ql-header">
                    <option value="1"></option>
                    <option value="2"></option>
                    <option value="3"></option>
                    <option value="4"></option>
                    <option value="5"></option>
                    <option value="6"></option>
                    <option selected="selected"></option>
                </select>
            </span>
            <span class="ql-formats">
                <select class="ql-font">
                    <option selected="selected"></option>
                    <option value="serif"></option>
                    <option value="monospace"></option>
                </select>
            </span>
            <span class="ql-formats">
                <select class="ql-color color">
                    <option selected></option>
                    <option value="#e60000"></option>
                    <option value="#ff9900"></option>
                    <option value="#ffff00"></option>
                    <option value="#008a00"></option>
                    <option value="#0066cc"></option>
                    <option value="#9933ff"></option>
                    <option value="#ffffff"></option>
                    <option value="#facccc"></option>
                    <option value="#ffebcc"></option>
                    <option value="#ffffcc"></option>
                    <option value="#cce8cc"></option>
                    <option value="#cce0f5"></option>
                    <option value="#ebd6ff"></option>
                    <option value="#bbbbbb"></option>
                    <option value="#f06666"></option>
                    <option value="#ffc266"></option>
                    <option value="#ffff66"></option>
                    <option value="#66b966"></option>
                    <option value="#66a3e0"></option>
                    <option value="#c285ff"></option>
                    <option value="#888888"></option>
                    <option value="#a10000"></option>
                    <option value="#b26b00"></option>
                    <option value="#b2b200"></option>
                    <option value="#006100"></option>
                    <option value="#0047b2"></option>
                    <option value="#6b24b2"></option>
                    <option value="#444444"></option>
                    <option value="#5c0000"></option>
                    <option value="#663d00"></option>
                    <option value="#666600"></option>
                    <option value="#003700"></option>
                    <option value="#002966"></option>
                    <option value="#3d1466"></option>
                </select>
                <select class="ql-background color">
                    <option selected></option>
                    <option value="#000000"></option>
                    <option value="#e60000"></option>
                    <option value="#ff9900"></option>
                    <option value="#ffff00"></option>
                    <option value="#008a00"></option>
                    <option value="#0066cc"></option>
                    <option value="#9933ff"></option>
                    <option value="#facccc"></option>
                    <option value="#ffebcc"></option>
                    <option value="#ffffcc"></option>
                    <option value="#cce8cc"></option>
                    <option value="#cce0f5"></option>
                    <option value="#ebd6ff"></option>
                    <option value="#bbbbbb"></option>
                    <option value="#f06666"></option>
                    <option value="#ffc266"></option>
                    <option value="#ffff66"></option>
                    <option value="#66b966"></option>
                    <option value="#66a3e0"></option>
                    <option value="#c285ff"></option>
                    <option value="#888888"></option>
                    <option value="#a10000"></option>
                    <option value="#b26b00"></option>
                    <option value="#b2b200"></option>
                    <option value="#006100"></option>
                    <option value="#0047b2"></option>
                    <option value="#6b24b2"></option>
                    <option value="#444444"></option>
                    <option value="#5c0000"></option>
                    <option value="#663d00"></option>
                    <option value="#666600"></option>
                    <option value="#003700"></option>
                    <option value="#002966"></option>
                    <option value="#3d1466"></option>
                </select>
            </span>
            <span class="ql-formats">
                <select class="ql-align">
                    <option selected></option>
                    <option value="center"></option>
                    <option value="right"></option>
                    <option value="justify"></option>
                </select>
            </span>
            <span class="ql-formats">
                <button type="button" class="ql-clean"></button>
            </span>
            <span class="ql-formats">
                <button class="ql-link"></button>
                <button class="ql-custom-button" @click="open">
                    <svg viewBox="0 0 18 18"> <rect class="ql-stroke" height="10" width="12" x="3" y="4"></rect> <circle class="ql-fill" cx="6" cy="7" r="1"></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>
                </button>
            </span>
          </div>
        </quill-editor>

        <v-overlay :value="getLoadingRedactor" absolute opacity="0.3">
            <v-progress-circular indeterminate size="64" />
        </v-overlay>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import "./Redactor.scss";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "Redactor",
  components: {
    quillEditor,
  },
  computed: {
    ...mapGetters({
      apiImg: "apiImg",
      userName: "login/userName",
      getSystemData: "tree/getSystemData",
      getContent: "tree/getContent",
      currentNode: "tree/currentNode",
      getLoadingRedactor: "tree/getLoadingRedactor",
      mediaData: "media/mediaData",
      mediaType: "media/mediaType",
    }),
  },
  data() {
    return {
      sideMenuOpened: false,
      dialog: false,
      search: "",
      page: 1,
      filter: {
        author: "",
        fileType: "",
      },
      itemsPerPage: 5,
      mediaArr: [],
      selected: [],
      paginations(event) {
        this.page = event.page;
        this.itemsPerPage = event.itemsPerPage;
      },
      content: "",
      converted: false,
      editing: false,
      editTimer: null,
      waitTimer: null,
      propertyType: 0,
      files: {
        nodeid: null,
        fileids: [],
        index: null,
      },
      editorOption: {
        placeholder: "Добавьте описание узла...",
        modules: {
          toolbar: "#toolbar",
        },
      },
      headers: [
        { text: "Описание", value: "description" },
        { text: "Тeги", value: "mediaFileTags" },
        { text: "Файл", value: "fileName" },
        { text: "", value: "actions", sortable: false, align: "right" },
      ],
    };
  },
  methods: {
    ...mapActions({
      getUserInfo: "user/getUserInfo",
      updateNode: "tree/updateNode",
      updateNodeContent: "tree/updateNodeContent",
      getFiles: "media/getFiles",
    }),
    ...mapMutations({
      setContent: "tree/setContent",
      changeLoadRedactor: "tree/changeLoadRedactor",
      mediaFilter: "media/mediaFilter",
    }),
    open() {
      this.mediaArr = this.mediaData;
      this.files.nodeid = this.currentNode.id;
      this.dialog = true;
    },
    filesReset() {
      this.search = "";
      this.filter.author = "";
      this.filter.fileType = "";
      this.files.nodeid = null;
      this.files.fileids = [];
      this.files.index = null;
    },
    close() {
      this.dialog = false;
      this.filesReset();
      this.getFiles();
    },
    convertContentToQuill() {
      this.convertMediaTagsToQuill(/<video.*?src="(.*?)".*?><\/video>/g, 'video');
      this.convertMediaTagsToQuill(/<audio.*?src="(.*?)".*?><\/audio>/g, 'audio');
    //   this.converted = true;
      return this.getContent;
    },
    convertMediaTagsToQuill(regex, type) {
      let result = this.getContent;

      if (this.converted || result === null) {
        return;
      }

      let matches = result.matchAll(regex);

      for (let match of matches) {
        // console.log('match', match);
        let mediaTag = match[0],
            mediaSource = match[1],
            iframeTag = `<iframe autoplay="false" controls="0" frameborder="0" allow="fullscreen" src="${mediaSource}"></iframe>`;
        
        result = result.replace(mediaTag, iframeTag);
      }

      this.setContent(result);
    },
    convertContentFromQuill() {
      let result = this.getContent;

      if (result === null) {
        return null;
      }

      const regex = /<iframe.*?src="(.*?)"><\/iframe>/g;
      let matches = result.matchAll(regex);

      for (let match of matches) {
        let iframeTag = match[0];
        let mediaSource = match[1];
        let mediaTag = null;

        if (mediaSource.endsWith(".mp4")) {
          mediaTag = `<video class="content-media" controls><source src="${mediaSource}" type="video/mp4"></video>`;
        } else if (mediaSource.endsWith(".mp3")) {
          mediaTag = `<audio class="content-media" controls><source src="${mediaSource}" type="audio/mpeg"></audio>`;
        }

        if (mediaTag !== null) {
          result = result.replace(iframeTag, mediaTag);
        }
      }

      return result;
    },
    editContent(item, id, text) {
      item.map((item) => {
        if (item.id == id) {
          item.content = text;
          return false;
        } else {
          if (item.children) {
            this.editContent(item.children, id, text);
          }
        }
      });
    },
    onEditorChange({ quill, html, text }) {
      clearTimeout(this.waitTimer);

      if (this.editing) {
        this.waitTimer = setTimeout(() => {
          this.onEditorChange({ html: html });
        }, 1000);

        return;
      }

      this.setContent(html);

      let node = {
        nodeId: this.currentNode.id,
        content: this.convertContentFromQuill(),
      };

      clearTimeout(this.editTimer);

      this.editTimer = setTimeout(() => {
        this.editing = true;
        this.changeLoadRedactor(true);
        this.updateNodeContent(node).then(() => {
          this.editing = false;
        
          setTimeout(() => {
            this.$refs.myQuillEditor.quill.focus();
            this.changeLoadRedactor(false);
          }, 10);
        });
      }, 2000);
    },
    addFiles() {
      this.$refs.myQuillEditor.quill.focus();
      this.selected.map((item) => {
        this.handleSuccess(item.fileUrl);
      });
    },
    handleSuccess(res) {
      this.$refs.myQuillEditor.quill.focus();
      let quill = this.$refs.myQuillEditor.quill;
      let length = this.$refs.myQuillEditor.quill.selection.savedRange.index;
      let format = _.last(res.split("."));
      if (res) {
        if (
          format === "jpeg" ||
          format === "jpg" ||
          format === "png" ||
          format === "JPG"
        ) {
          quill.insertEmbed(length, "image", `${this.apiImg}${res}`);
        } else if (format === "mp4" || format === "mp3") {
          quill.insertEmbed(length, "video", `${this.apiImg}${res}`);
        }
        quill.setSelection(length + 1);
      } else {
        // console.log("ошибка");
      }
      this.selected = [];
      this.close();
    },
  }
};
</script>
